import React from "react";
import "./ThumbnailImage.style.css"; // See CSS below

const ThumbnailImage = ({
  src,
  size = 55,
  borderRadius = 8,
  style = {},
  onError,
}) => {
  const resolvedSize = typeof size === "number" ? `${size}px` : size;
  const resolvedRadius = typeof borderRadius === "number" ? `${borderRadius}px` : borderRadius;

  return (
    <div
      className="thumbnail-root"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        borderRadius: resolvedRadius,
        ...style,
      }}
    >
      <img
        src={src}
        alt={"thumbnail-img"}
        className="thumbnail-img"
        style={{
          borderRadius: resolvedRadius,
        }}
        draggable={false}
        loading="lazy"
        onError={onError}
      />
    </div>
  );
};

export default ThumbnailImage;